export default __webpack_public_path__ + "./images/sg.020c996f.png";